import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Abstract', id: 'abstract' },
  { label: 'Motivation', id: 'motivation' },
  { label: 'Insights', id: 'insights' },
  { label: 'Method', id: 'methodology' },
  { label: 'Experiments', id: 'experiment' },
  { label: 'BibTeX', id: 'bibtex' },
];

export default function Header({ currentSection = 'abstract' }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'backdrop-blur-md bg-white/75 border-b border-ink-100 shadow-soft'
          : 'bg-white/0 border-b border-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 flex justify-between items-center h-14">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2 group">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-grad-brand-accent text-white font-bold text-sm shadow-sm">
            B
          </span>
          <span className="text-base md:text-lg font-semibold tracking-tight text-ink-900 group-hover:text-brand-600 transition-colors">
            BD-VAX
          </span>
          <span className="hidden lg:inline text-sm text-ink-400 font-medium ml-1">
            · Backdoor Signature
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const isActive = currentSection === item.id;
            return (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`relative px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive ? 'text-brand-700' : 'text-ink-500 hover:text-ink-900'
                }`}
              >
                {item.label}
                {isActive && (
                  <span className="absolute left-2 right-2 -bottom-0.5 h-[2px] rounded-full bg-grad-brand-accent-r" />
                )}
              </a>
            );
          })}
        </nav>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-ink-700 p-2 -mr-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile nav dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur border-t border-ink-100">
          <ul className="flex flex-col py-2">
            {navItems.map((item) => {
              const isActive = currentSection === item.id;
              return (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={() => setIsOpen(false)}
                    className={`block px-6 py-2.5 text-sm transition-colors ${
                      isActive
                        ? 'text-brand-700 font-semibold bg-brand-50/60'
                        : 'text-ink-600 hover:bg-ink-50'
                    }`}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </header>
  );
}
